import { george, pr, theme, ui } from "aaa";
import * as React from "react";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { safeWindowOpen } from "util/helpers";
import { CancelButton } from "../components/CancelButton";
import { ContinueButton } from "../components/ContinueButton";
import { ScreenWithBottomAction } from "../components/ScreenWithBottomAction";
import { JuniorRoutes } from "../JuniorRoutes";

export const JuniorActivationActivateApp = () => {

    const handleBack = () => {
        pushRoute(JuniorRoutes.ACTIVATION_DOWNLOAD_APP);
    };

    const handleOpenSettings = () => {
        const deeplink = "georgeapp://at/deeplink?path=junior-settings";
        const url = `${externalInterfaceStore.georgeBaseUrl}/index.html?crossPlatform=true&at=c#settings`;
        safeWindowOpen(
            externalInterfaceStore.isGeorgeApp ? deeplink : url,
            "_blank"
        );
    };

    return (
        <ScreenWithBottomAction
            title={ui.__("gJunior.activation.activateApp.title")}
            ContinueButton={
                <ContinueButton
                    messageId="gJunior.activation.activateApp.primaryButton"
                    onClick={handleOpenSettings}
                />
            }
            CancelButton={
                <CancelButton
                    onClick={handleBack}
                    messageId="gJunior.activation.activateApp.back"
                />
            }
        >
            <pr.P_16_CONTENT
                style={{
                    marginTop: theme.MARGIN_SMALL,
                    lineHeight: "22px",
                }}
            >
                {ui.__("gJunior.activation.activateApp.intro")}
            </pr.P_16_CONTENT>

            <george.Card
                elevated={false}
                style={{
                    borderRadius: theme.BORDER_RADIUS_LARGE,
                    padding: 0,
                    marginTop: theme.MARGIN,
                    width: "100%",
                    overflow: "hidden",
                    boxShadow: ui.isDarkMode ? undefined : "0 2px 12px rgba(15, 23, 42, 0.08)",
                }}
            >
                <div style={{ padding: theme.MARGIN }}>
                    <div style={{ display: "flex", gap: theme.MARGIN }}>

                        <img
                            src={require("../../../assets/gJunior/activation_george_icon.png")}
                            alt=""
                            style={{ width: 24, height: 24, objectFit: "contain" }}
                        />

                        <div style={{ flex: 1, minWidth: 0 }}>
                            <pr.P_16_TITLE
                                style={{
                                    fontWeight: 700,
                                    margin: 0,
                                    lineHeight: "24px",
                                }}
                            >
                                {ui.__("gJunior.activation.activateApp.step1.title")}
                            </pr.P_16_TITLE>
                            <pr.P_16_CONTENT
                                style={{
                                    marginTop: theme.MARGIN_SMALL,
                                    marginBottom: 0,
                                    lineHeight: "22px",
                                }}
                            >
                                {ui.__("gJunior.activation.activateApp.step1.body")}
                            </pr.P_16_CONTENT>


                            <pr.P_14_CONTENT
                                style={{
                                    marginTop: theme.MARGIN_SMALL,
                                    lineHeight: "20px",
                                }}
                            >
                                {ui.__("gJunior.activation.activateApp.step1.hint")}
                            </pr.P_14_CONTENT>

                        </div>
                    </div>
                </div>

                <pr.LightSeparatorLine />

                <div style={{ padding: theme.MARGIN }}>
                    <div style={{ display: "flex", gap: theme.MARGIN }}>

                        <img
                            src={require("../../../assets/gJunior/activation_qr_icon.png")}
                            alt=""
                            style={{ width: 24, height: 24, objectFit: "contain" }}
                        />

                        <div style={{ flex: 1, minWidth: 0 }}>
                            <pr.P_16_TITLE
                                style={{
                                    fontWeight: 700,
                                    margin: 0,
                                    lineHeight: "24px",
                                }}
                            >
                                {ui.__("gJunior.activation.activateApp.step2.title")}
                            </pr.P_16_TITLE>
                            <pr.P_16_CONTENT
                                style={{
                                    marginTop: theme.MARGIN_SMALL,
                                    marginBottom: 0,
                                    lineHeight: "22px",
                                }}
                            >
                                {ui.__("gJunior.activation.activateApp.step2.body")}
                            </pr.P_16_CONTENT>
                        </div>
                    </div>
                </div>
            </george.Card>
        </ScreenWithBottomAction>
    );
};



// WEBPACK FOOTER //
// ./src/components/gJunior/activationStep/JuniorActivationActivateApp.tsx